import { Assets, Container, Renderer, Sprite } from 'pixi.js';

import assertDefined from 'app/utils/assert-defined';
import { getResizeUri } from 'app/utils/image';
import CTAItem from 'entity/CTAItem';

import { createButtonText, generateButtonTexture } from '../../social-pixi-canvas/cta/cta-item';

export const createCTAButton = (renderer: Renderer, item: CTAItem, ratio: number): Container | undefined => {
  if (!item.CTAItemId) {
    return undefined;
  }

  const button = createButton(renderer, item, ratio);
  return button;
};

const createButton = (renderer: Renderer, item: CTAItem, ratio: number): Container => {
  const { buttonColor, buttonTextColor, text, x, y } = item;
  const container = new Container();
  container.name = `cta-button-container-${item.CTAItemId}`;
  const buttonText = createButtonText(text ?? '', ratio, buttonTextColor);
  buttonText.anchor.set(0.5, 0.5);
  const texture = generateButtonTexture(renderer, ratio, buttonColor);
  const sprite = Sprite.from(texture);
  sprite.name = `cta-button-${item.CTAItemId}`;
  sprite.anchor.set(0.5, 0.5);
  sprite.visible = true;
  container.addChild(sprite, buttonText);
  container.position.set(x, y);
  return container;
};

export const getImageInfo = (
  a: CTAItem,
  ratio: number,
): { height: number; width: number; imageURI: string; x: number; y: number; id: number } => {
  assertDefined(a.imageURI);
  const height = (a.imageHeight ?? 0) * ratio;
  const width = (a.imageWidth ?? 0) * ratio;
  const imageURI = getResizeUri({ uri: a.imageURI, height, width });
  const x = a.x ?? 0;
  const y = a.y ?? 0;
  const id = a.CTAItemId ?? Date.now();
  return { height, width, imageURI, x, y, id };
};

export const createCTAImage = (item: CTAItem, ratio: number, compressed: boolean): Promise<Sprite | null> => {
  return new Promise(async (resolve): Promise<void> => {
    if (!item.CTAItemId || !item.imageURI) {
      resolve(null);
      return;
    }
    const { height, width, x, y } = getImageInfo(item, ratio);
    // const ctaAsset = await Assets.load((compressed ? item.imageURI?.replace('webp', 'ktx2') : item.imageURI) ?? '');
    const ctaAsset = await Assets.load(item.imageURI ?? '');
    const sprite = Sprite.from(ctaAsset);
    sprite.name = `cta-asset-${item.CTAItemId}`;
    sprite.width = width;
    sprite.height = height;
    sprite.position.set(x, y);

    resolve(sprite);
  });
};
